'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var Badge = require('../../../node_modules/@material-ui/core/esm/Badge/Badge.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    sizes: function sizes(props) {
      return {
        minHeight: props.minSizes,
        minWidth: props.minSizes,
        borderRadius: props.minSizes / 2
      };
    },
    badgeColor: function badgeColor(_ref) {
      var _theme$palette$_color, _theme$palette$_color2;

      var _color = _ref._color;
      return {
        backgroundColor: ((_theme$palette$_color = theme.palette[_color]) === null || _theme$palette$_color === void 0 ? void 0 : _theme$palette$_color.main) || theme.palette.primary.main,
        color: ((_theme$palette$_color2 = theme.palette[_color]) === null || _theme$palette$_color2 === void 0 ? void 0 : _theme$palette$_color2.contrastText) || theme.palette.primary.contrastText
      };
    }
  };
});

var BadgeBase = function BadgeBase(_ref2) {
  var classes = _ref2.classes,
      _ref2$version = _ref2.version,
      version = _ref2$version === void 0 ? '' : _ref2$version,
      children = _ref2.children,
      color = _ref2.color,
      restProps = objectWithoutProperties(_ref2, ["classes", "version", "children", "color"]);

  var minSizes = restProps.variant === 'dot' ? 16 : 24;
  var isV2 = version === 'v2';

  var _useStyles = useStyles({
    _color: color,
    minSizes: minSizes
  }),
      sizes = _useStyles.sizes,
      badgeColor = _useStyles.badgeColor;

  return React__default["default"].createElement(Badge["default"], _objectSpread({
    classes: isV2 ? _objectSpread({
      badge: "".concat(sizes, " ").concat(badgeColor)
    }, classes) : classes,
    color: isV2 ? 'default' : color
  }, restProps), children);
};

module.exports = BadgeBase;
